/**
 * @generated SignedSource<<fc4a7c626929757050cd2bf69281ebe7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomNameWithCapacity_room$data = {
  readonly capacity: number | null;
  readonly nameString: string | null;
  readonly " $fragmentType": "RoomNameWithCapacity_room";
};
export type RoomNameWithCapacity_room$key = {
  readonly " $data"?: RoomNameWithCapacity_room$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomNameWithCapacity_room">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomNameWithCapacity_room",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameString",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacity",
      "storageKey": null
    }
  ],
  "type": "Room",
  "abstractKey": null
};

(node as any).hash = "5f37cf6c493cb9399db6ea9069b9fda8";

export default node;
